import { t } from "i18next";
import { SelectInputData } from "../../../../../components/deprecated/SelectInputField/SelectInputField";
import { CreatedBySource } from "../../CreatedByData";
import { DataObjectType } from "../../DataObjects/DataObjectHelper";
import { FirebaseDataSelectField, FirebaseDataSelectFieldOption } from "../Generic/FirebaseDataSelectField";

export class FirebaseDataSourceField<FirebaseDataType extends DataObjectType> extends FirebaseDataSelectField<CreatedBySource, FirebaseDataType> {
  encode = (value: CreatedBySource) => value;
  override convertValueToSelectInput(value: CreatedBySource): SelectInputData {
    return new SelectInputData(value + "", t("main.createdBySource." + value));
  }
  getValueForKey(key: string): CreatedBySource | undefined {
    if (key === "user") {
      return "user";
    }
    if (key === "ai") {
      return "ai";
    }

    if (key === "api") {
      return "api";
    }
  }
  getOptions(): FirebaseDataSelectFieldOption[] {
    return [
      {
        key: "user",
        label: t("main.createdBySource.user"),
      },
      {
        key: "ai",
        label: t("main.createdBySource.ai"),
      },
      {
        key: "api",
        label: t("main.createdBySource.api"),
      },
    ];
  }
  getReadableStringRepresentation(value: CreatedBySource): string {
    return t("main.createdBySource." + value);
  }

  override isValueValid = (value: any): boolean => {
    return value === "user" || value === "ai" || value === "api";
  };
}

